import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const StatsGql = gql`
  query stats(
    $filterTotalFrom: Int,
    $filterTotalTo: Int,
    $filterPaid: [String!]
    $filterSearch: String,
    $filterStateId: [String!],
    $filterCreatedFrom: String,
    $filterCreatedTo: String,
    $filterDeliveryMethodId: [String!],
    $filterPaymentMethodId: [String!],
    $eshopDomain: String!, 
    $customerId: String
  ) {
    stats(
      where: {
          customerId: $customerId, 
          eshop: { domain: $eshopDomain },
          search: $filterSearch,
          stateId: $filterStateId,
          deliveryMethodId: $filterDeliveryMethodId,
          paymentMethodId: $filterPaymentMethodId,
          createdFrom: $filterCreatedFrom,
          createdTo: $filterCreatedTo,
          totalFrom: $filterTotalFrom,
          totalTo: $filterTotalTo,
          paid: $filterPaid
      }
    ) {
      total
      currency
    }
  }
`;

export interface StatsOrderFilter {
  query?: string;
  page: number | undefined;
  createdAtFrom: string | null;
  createdAtTo: string | null;
  orderAmountFrom: string | null;
  orderAmountTo: string | null;
  orderState: string[] | null;
  orderPaid: string[] | null;
  deliveryMethod: string[] | null;
  paymentMethod: string[] | null;
}

interface IInputProps {
  children?: any;
  filter: StatsOrderFilter;
  search?: string;
  eshopId: string;
  domain: string;
  customerId?: string;
}

interface Response {
  data: any;
}

class StatsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  public render() {
    const { stats }: any = this.props;
    return this.props.children({
      stats,
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(StatsGql, {
    name: 'stats',
    options: props => {
    return ({
      variables: {
        filterSearch: props.filter && props.filter.query || '',
        eshopDomain: props.domain ? props.domain : '',
        customerId: props.customerId,
        filterStateId: props && props.filter.orderState,
        filterCreatedFrom: props.filter && props.filter.createdAtFrom,
        filterCreatedTo: props.filter && props.filter.createdAtTo,
        filterDeliveryMethodId: props.filter && props.filter.deliveryMethod,
        filterPaymentMethodId: props.filter && props.filter.paymentMethod,
        filterPaid: props.filter && props.filter.orderPaid,
        filterTotalFrom: props.filter && props.filter.orderAmountFrom,
        filterTotalTo: props.filter && props.filter.orderAmountTo,
      },
    })
  }}),
)(StatsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Orders/Stats.tsx